import React from "react";

const UserPopupMenuComp = (props) => {
  return (
    <div className="popup-menu">
      <span className="closebtn" onClick={props.handleClose}>
        &times;
      </span>
      <div className="popup-menu-content">
        <ul className="popup-menu-items">
          <li onClick={() => props.handleMenuClick("/profile")}>
            <img src="/img/icon/profile.svg" alt="icon profile" />
            <div className="popup-menu-icon-label">User Profile</div>
          </li>
          <li onClick={() => props.handleMenuClick("/logout")}>
            <img src="/img/icon/logout.svg" alt="icon logout" />
            <div>Logout</div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default UserPopupMenuComp;
